import styled from 'styled-components/macro';
import { lowHeightScreens, mediumScreens, smallScreens } from '../../../common/fontElements';
import * as colors from 'components/common/colorConstants';

export const Container = styled.div`
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  height: 100% !important;
  overflow-y: scroll;
  padding: 0 25px 100px;
  background-color: #fff;
  font-size: 13px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 12px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 10px;
  }
`;

export const ContentWrapper = styled.div`
  padding: 0 10px 200px;
  position: ${(props) => props.position || 'static'};
  left: 0;
  right: 0;
`;

export const TitleText = styled.p`
  font-family: Lato, serif;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: 0;
  text-align: center;
  color: ${colors.black1};
  margin: 0;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 13px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }
`;

export const PageHeader = styled.div`
  padding: 70px 0 30px;
  border-bottom: 1px solid #d8e8ef;
  text-align: center;
  @media (max-height: ${smallScreens}) {
    padding: 20px 0 20px;
  }
`;

export const Icon = styled.img`
  padding-bottom: 20px;
  @media (max-height: ${smallScreens}) {
    display: none;
  }
`;

export const AddressWrapper = styled.div`
  margin: 4rem;
  label {
    color: #7f7f7f;
    font-family: lato, sans-serif;
    line-height: 1.8rem;
    font-weight: 700;
  }
`;

export const ErrorMessageWrapper = styled.div`
  width: 100%;
  text-align: center;
  color: #ff4d44;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0 0 0;
`;

export const PrimaryButton = styled.button`
  background-color: #44b1df;
  border: 0 #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2rem;

  &:hover {
    background-color: #545454;
  }
`;
